/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import _ from 'lodash';
import s from './ValidacionesTecnicas.css';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
import ModalVideoLlamada from '../ModalVideoLlamada/ModalVideoLlamada';
import Icondesktop from '../../../../public/images/ic_desktop.png';
import IconMicrophone from '../../../../public/images/ic_microphone.png';
import IconPadlock from '../../../../public/images/ic_padlock.png';
import IconVideo from '../../../../public/images/ic_video.png';
import IconCheck from '../../../../public/images/validacion green.png';
import IconCross from '../../../../public/images/Validacion red.png';
import BrokenCable from '../../../../public/images/broken-cable.png';
import ModalTurnoElegidoYaFueSeleccionado from '../ModalTurnoElegidoYaFueSeleccionado/ModalTurnoElegidoYaFueSeleccionado';
import ModalConsultaSinFinalizar from '../../../components/Telemedicina/ModalConsultaSinFinalizar/ModalConsultaSinFinalizar';
import ModalUserMediaError from '../../../components/Telemedicina/ModalUserMediaError/ModalUserMediaError';
import ModalIngresoDireccionActual from '../../ModalIngresoDireccionActual/ModalIngresoDireccionActual';
/* import ModalCalificacion from '../../../components/Telemedicina/ModalCalificacion/ModalCalificacion'; */
import { LOCALSTORAGE_AUTH_KEY } from '../../../constants/index';
import redirectTo from '../../../utils/redirectTo';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
//import {checkCrossnet} from '../../../utils/requests'

//import MonitoringUtil from '../../../utils/monitoringUtil.js';

let ComponentValidation = (props) => {
  return (<div className={`${s.validacion_row} col-md-11 row`}>
            <div className="col-md-1"
              style={{ height: '44px', textAlign: 'center' }}>
              <img alt="icon" src={props.icon} />
                <img
                  className={`${s.crossIcon}`}
                  alt="icon"
                  src={props.checkIcon}
                />
            </div>
            <div className={props.msgClass}>
              {props.msg}
            </div>
          </div>)
}

let PeriphericCheckComponent = (props) => {
  return (
    <div>
      {props.validation ?
        <ComponentValidation icon={props.icon} checkIcon={IconCheck} msg={props.msgSuccess} msgClass={props.msgClass}/>
      :
        <ComponentValidation icon={props.icon} checkIcon={IconCross} msg={props.msgError} msgClass={props.msgClass}/> 
      }
    </div>
  )
}

class ValidacionesTecnicas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationVideo: false,
      validationMicro: false,
      iniciarLlamada: false,
      turnoOcupado: false,
      validationCrossnet: false,
      turno: null,
      direccion: '',
      hasMediaError: false,
      urlLink:null,
      velidateTel:false,
      credential:null
    };
    this.validateVideo = this.validateVideo.bind(this);
    this.validateMicro = this.validateMicro.bind(this);
    this.changeStateVideo = this.changeStateVideo.bind(this);
    this.changeStateMicro = this.changeStateMicro.bind(this);
    this.onButtonContinuarClick = this.onButtonContinuarClick.bind(this);
    this.volverAConsultaTurnos = this.volverAConsultaTurnos.bind(this);
    this.setHasMediaError = this.setHasMediaError.bind(this);
    //this.openInNewTab = this.openInNewTab.bind(this);
    
  }

  componentDidMount() {
    this.validateMicro();
    this.validateVideo();
    this.props.fetchEmail();
    //checkCrossnet(this);
    if (this.props.origen === 'espontaneo') {
      this.props.fetchPrepaga();
    }

    if (this.props.origen === 'consulta') {
      this.setState({ turno: this.props.validaciones_tecnicas.data });
    }

    if (this.props.origen === 'mail') {
      const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
      const token = datos.token;
      this.props.fetchDomicilioAfiliado();
      const url = new URL(window.location.href);
      const turnoEncrypted = url.searchParams.get('token');

      const json = {
        token,
        data: turnoEncrypted,
      };

      fetch(`${generateAbsoluteUrl()}/api/desencriptarToken`, {
        method: 'POST',
        body: JSON.stringify(json),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      })
        .then(res => res.json())
        .then(response => {
          this.setState({ turno: response.idTurno });
          this.obtenerDetalleTurno(this.state.turno);
        });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.tomarTurnoSuccess)) {
      if (_.isEmpty(nextProps.tomarTurnoSuccess.error)) {
        this.setState({
          turno: nextProps.tomarTurnoSuccess.turno,
          //iniciarLlamada: true,
          iniciarLlamada: false,
        });
      } else {
        this.setState({
          turnoOcupado: true,
        });
      }
    }
  }

  setHasMediaError = () => {
    this.setState({hasMediaError : true });
  }

  componentWillUnmount() {
    this.state = {
      validationVideo: false,
      validationMicro: false,
      iniciarLlamada: false,
      turnoOcupado: false,
      validationCrossnet: false,
      turno: null,
      direccion: '',
    };
    this.props.espontaneoEnd()
  }

  openInNewTab(url) {
    var win = window.open(url, '_blank');
    this.volverAConsultaTurnos();
    win.focus();
  }
  
   validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  onButtonContinuarClick (direccion,telefono,telefono2,email) {

    this.setState({
      velidateTel: false,
    });
    //Validation mail
     let prueba = this.validateEmail(email);
     this.props.validateEmail(prueba);
     this.props.credentialUser()
       .then((data)=>{
        this.setState({
          credential: this.props.numberCredentialUser
       });
        })
       .catch((err)=>{
              console.error(err)
       })
    const oldTelephone = this.props.get_telefonos;
    const especialidad = this.props.id_especialidad;
    const motivo = this.props.id_motivo;
    //const urlLink= this.props.linkDoc && this.props.linkDoc.data.url_email;
    //const email = this.props.email
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    
    const token = datos.token;
    const dataToken = {
      token,
    };
    setTimeout(() => {
      if(telefono2 === '' || telefono === ''){
        this.setState({
          velidateTel: true,
        });
        this.props.validateSubmitSuccess('El numero de telefono es obligatorio')
        return false;
      }
      if(telefono === telefono2){
        this.setState({
          velidateTel: true,
        });
        this.props.validateSubmitSuccess('Deben ser diferentes numeros de telefono')
        return false;
      }
      if(!this.props.valEmail){
        this.props.validateSubmitSuccess('El mail debe ser valido')
        return false;
      }

      if(telefono !== "") {
      this.props.postTelefonoAfiliado(oldTelephone,telefono,email,telefono2);
      this.props.fetchEspontaneo(especialidad,23912, this.props.prepaga);
      this.props.postLinkDoc(oldTelephone,telefono,telefono2,email,especialidad,motivo,this.props.numberCredentialUser)
         .then((data)=>{
                 this.setState({
                    urlLink: this.props.linkDoc
                 });
         })
         .catch((err)=>{
           console.error(err);
         })
         .finally(()=>{
          this.openInNewTab(this.state.urlLink);
          this.props.tomarTurno(this.props.prepaga,especialidad);
          //this.props.closeSelectEspecialidades(true);
          $('.modal-backdrop').hide();
        })
    // setTimeout(() => {
    //   this.setState({
    //     urlLink: this.props.linkDoc
    //   });
    //   this.openInNewTab(this.state.urlLink);
    //   this.props.closeSelectEspecialidades(true);
    //   $('.modal-backdrop').hide();
    // }, 5000);
      }
      else{
        return;
      }
    }, 1500);

    // const contra = datos.modelEspecifico.contra;
    // const inte = datos.modelEspecifico.inte;
    // newrelic.setCustomAttribute(
    //   'message',
    //   'VALIDACIONES - TECNICAS CONTINUAR O INICIAR CONSULTA',
    // );
    // newrelic.setCustomAttribute('contra', contra);
    // newrelic.setCustomAttribute('inte', inte);

    //Monitoring log
    //const monitoringUtil = new MonitoringUtil();
    //monitoringUtil.createAffilliateLog({ interaction:"VALIDACIONES - TECNICAS CONTINUAR", message:"El afiliado paso las validaciones tecnicas y continua con el proceso de la llamada." });  

    // fetch(`${generateAbsoluteUrl()}/renew-token`, {
    //   method: 'POST',
    //   body: JSON.stringify(dataToken),
    //   headers: new Headers({
    //     'Content-Type': 'application/json',
    //   }),
    // })
    //   .then(res => res.json())
    //   .then(response => {
    //     if (response.data && response.data.token && response.data.exp) {
    //       const authData = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
    //       const authJson = JSON.parse(authData);
    //       authJson.token = response.data.token;
    //       authJson.exp = response.data.exp;
    //       localStorage.setItem('token', JSON.stringify(authJson.token));
    //       localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(authJson));
    //     }
    //     this.setState({
    //       direccion,
    //     });
    //     if (this.props.origen === 'espontaneo') {
    //       this.props.tomarTurno(
    //         this.props.prepaga,
    //         this.props.practica,
    //         this.props.especialidad,
    //       );
    //     } else if (this.props.origen === 'mail' ||
    //                this.props.origen === 'consulta') {
    //       this.setState({
    //         iniciarLlamada: true,
    //       });
    //     }
    //   });
  }

  onButtonReintentarClick() {
    this.validateMicro();
    this.validateVideo();
  }

  validateVideo() {
    navigator.getMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;

    navigator.getMedia(
      { video: true },
      stream => {
        this.changeStateVideo(true);
        stream.stop();
      },
      stream => {
        this.changeStateVideo(false);
        stream.stop();
      },
    );
  }

  validateMicro() {
    navigator.getMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;

    navigator.getMedia(
      { audio: true },
      () => this.changeStateMicro(true),
      () => this.changeStateMicro(false),
    );
  }
  changeStateMicro(value) {
    this.setState({
      validationMicro: value,
    });
  }
  changeStateVideo(value) {
    this.setState({
      validationVideo: value,
    });
  }

  obtenerDetalleTurno(turno) {
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
    const token = datos.token;
    const contra = datos.modelEspecifico.contra;
    const inte = datosInteSelected.inte;
    const url = `${generateAbsoluteUrl()}/api/getTurnoPorId`;
    const dataDetail = {
      token,
      contra,
      inte,
      idTurno: turno,
    };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(dataDetail),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    })
      .then(res => res.json())
      .then(response => {
        this.setState({ turno: response });
      });
  }

  volverAConsultaTurnos() {
    this.props.hideValidacionesTecnicas();
    redirectTo('/telemedicina/solicitud-turnos');
  }

  render() {

    if (this.props.domicilio) {
      this.domicilioParticular = `${this.props.domicilio.calle} ${this.props
        .domicilio.numero}, ${this.props.domicilio.partido}, ${this.props
        .domicilio.cp}`;
    }
    // if (!this.state.iniciarLlamada) {
    //   const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    //   const contra = datos.modelEspecifico.contra;
    //   const inte = datos.modelEspecifico.inte;
    //   newrelic.setCustomAttribute(
    //     'message',
    //     'EL PACIENTE NO CUMPLE LOS REQUISITOS PARA INICIAR LA LLAMADA',
    //   );
    //   newrelic.setCustomAttribute('contra', contra);
    //   newrelic.setCustomAttribute('inte', inte);

    //   //Monitoring log
    //   if(!(this.state.validationVideo && this.state.validationMicro && this.state.validationCrossnet)){
    //     //const monitoringUtil = new MonitoringUtil();
    //     //monitoringUtil.createAffilliateLog({ interaction:"VALIDACIONES TECNICAS - NO PASADAS", message:"El afiliado no paso las validaciones tecnicas requeridas para iniciar la llamada." });    
    //   }   
    // }
    return (
      <div className={`${s.root}`}>
        {this.state.hasMediaError ? <ModalUserMediaError /> : ""}
        <ModalConsultaSinFinalizar />
        {/* <ModalCalificacion /> */}
        <div
          className={`${s.container} col-md-10`}
          style={{ marginTop: '50px' }}
        >
          <div className={`${s.validacion_row} col-md-12 row`}>
            <div className="col-md-1" style={{ textAlign: 'center' }}>
              <img alt="icon" src={Icondesktop} />
            </div>
            <div className="col-md-11">
                <strong>
                    Tu consulta se iniciará una vez que chequeemos que tu cámara
                    y<br />
                    micrófono funcionan correctamente.
                </strong>
              {/* {!this.state.iniciarLlamada
                ? <strong>
                    Tu consulta se iniciará una vez que chequeemos que tu cámara
                    y<br />
                    micrófono funcionan correctamente.
                  </strong>
                : <strong>
                    Tu consulta ha sido iniciada, por favor aguardá a ser
                    atendido <br />
                    por uno de nuestros médicos.
                  </strong>} */}
            </div>
          </div>
          <PeriphericCheckComponent validation={this.state.validationMicro} 
                                    icon={IconMicrophone}
                                    msgSuccess="Recordá que es mejor utilizar auriculares para que la calidad de
                                    audio sea óptima."
                                    msgError="Tu micrófono no funciona correctamente, por favor chequealo
                                    para continuar."
                                    msgClass="col-md-11"
                                    />
          <PeriphericCheckComponent validation={this.state.validationVideo}
                                    icon={IconVideo}
                                    msgSuccess="Es necesario que poseas una webcam para que el médico pueda
                                    observar tu estado y síntomas."
                                    msgError="Tu cámara no funciona correctamente, por favor chequeala
                                    para continuar."
                                    msgClass="col-md-11"
                                    />
          <PeriphericCheckComponent validation={this.state.validationVideo && this.state.validationMicro}
                                    icon={IconPadlock}
                                    msgSuccess="Tu navegador va a solicitar los permisos para utilizar la webcam 
                                    y el micrófono, recordá habilitarlos."
                                    msgError="Tu navegador va a solicitar los permisos para utilizar la webcam 
                                    y el micrófono, recordá habilitarlos."
                                    msgClass="col-md-11"
                                    />
          {/* <PeriphericCheckComponent validation={this.state.validationCrossnet}
                                    icon={BrokenCable}
                                    msgSuccess="Vamos a verificar que tu configuración de red sea compatible con E-Consulta."
                                    msgError="No se ha podido establecer conexión con el servidor proxy."
                                    msgClass="col-md-7"
                                    /> */}

          <div className="col-md-12 row" style={{ marginBottom: '25px', marginTop: '25px'  }}>
            <div className="col-md-3">
              {/* {this.state.validationVideo && this.state.validationMicro && this.state.validationCrossnet */}
              {this.state.validationVideo && this.state.validationMicro 
                ? <button
                    id="openModalButton"
                    className={`${s.boton_rojo} btn btn-default text-center`}
                    onClick={() => this.props.fetchDomicilio()}
                  >
                    Continuar
                  </button>
                : <button
                    className={`${s.boton_rojo} btn btn-default text-center`}
                    onClick={() => this.onButtonReintentarClick()}
                  >
                    Reintentar
                  </button>}
              <div>
                <button
                  onClick={() => this.volverAConsultaTurnos()}
                  className={`${s.boton_volver}`}
                >
                  <i className="glyphicon glyphicon-chevron-left" /> Volver a
                  solicitud de turnos
                </button>
              </div>
            </div>
            <div className="col-md-10" />
          </div>
          {this.state.turnoOcupado
            ? <ModalTurnoElegidoYaFueSeleccionado
                proximoTurno={this.props.proximoDisponible}
              />
            : ''}
          {this.props.domicilio
            ? <ModalIngresoDireccionActual
                direccion={this.domicilioParticular}
                telefono={this.props.telefono}
                oldTelephone={this.props.get_telefonos}
                continuar={this.onButtonContinuarClick}
                valEmail={this.props.valEmail}
                velidateTel={this.state.velidateTel}
                validateSubmit={this.props.validateSubmit}
              />
            : ''}
        </div>
        {this.state.iniciarLlamada
          ? <div className="col-md-1">
              <ModalVideoLlamada
                turno={this.state.turno}
                espontaneo={this.props.llamada_espontanea}
                origen={this.props.origen}
                direccion={this.state.direccion}
                prepaga={this.props.prepaga}
                practica={this.props.practica}
                especialidad={this.props.especialidad}
                setHasMediaError={this.setHasMediaError}
              />
            </div>
          : ''}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tomarTurnoSuccess: state.telemedicina.turnoTomado,
  domicilioAfiliado: state.telemedicina.domicilio_particular,
  domicilio: state.telemedicina.domicilio,
  prepaga: state.telemedicina.prepaga,
  practica: state.telemedicina.practica,
  proximoDisponible: state.telemedicina.proximoDisponible,
  llamada_espontanea: state.telemedicina.llamada_espontanea,
  email:state.telemedicina.email,
  telefono:state.telemedicina.telefono,
  get_telefonos: state.telemedicina.get_telefonos,
  id_especialidad: state.telemedicina.id_especialidad,
  id_motivo: state.telemedicina.id_motivo,
  linkDoc:state.telemedicina.linkDoc,
  valEmail:state.telemedicina.valEmail,
  validateSubmit:state.telemedicina.validateSubmit,
  numberCredentialUser:state.telemedicina.numberCredentialUser
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(ValidacionesTecnicas),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ValidacionesTecnicas/ValidacionesTecnicas.js